import { AbilityBuilder, Ability } from '@casl/ability';
import defineAdminPermissions from 'services/authorization/roles/admin';
import defineViewerPermissions from 'services/authorization/roles/viewer';
import defineEditorPermissions from 'services/authorization/roles/editor';
import defineRestrictedViewerPermissions from 'services/authorization/roles/restricted-viewer';
import defineFillerPermissions from 'services/authorization/roles/filler';
import defineLinkerPermissions from 'services/authorization/roles/linker';
import defineFillerLinkerPermissions from 'services/authorization/roles/filler-linker';
import defineOwnerPermissions from 'services/authorization/roles/owner';

// Roles are defined per surface

export enum SurfaceRoles {
  owner = 'OWNER',
  admin = 'ADMIN',
  viewer = 'VIEWER',
  editor = 'EDITOR',
  restrictedViewer = 'RESTRICTED_VIEWER',
  linker = 'LINKER',
  fillerLinker = 'FILER_LINKER',
  filler = 'FILLER',
}

interface Input {
  user: string;
  role: string;
}

export default function defineAbilityFor({ role, user }: Input) {
  const builder = new AbilityBuilder(Ability);

  switch (role) {
    case SurfaceRoles.owner:
      defineOwnerPermissions(builder, user);
      break;

    case SurfaceRoles.admin:
      defineAdminPermissions(builder, user);
      break;

    case SurfaceRoles.viewer:
      defineViewerPermissions(builder, user);
      break;

    case SurfaceRoles.editor:
      defineEditorPermissions(builder, user);
      break;

    case SurfaceRoles.restrictedViewer:
      defineRestrictedViewerPermissions(builder, user);
      break;

    case SurfaceRoles.filler:
      defineFillerPermissions(builder, user);
      break;

    case SurfaceRoles.linker:
      defineLinkerPermissions(builder, user);
      break;

    case SurfaceRoles.fillerLinker:
      defineFillerLinkerPermissions(builder, user);
      break;
  }

  return builder.build();
}
